export default "__VITE_ASSET__NAWZRkuI__"